import { permissionUser } from '@/api/permission';

const state = {
    menuList: []
};

const mutations = {
    SET_MENU_LIST(state, menuList) {
        state.menuList = menuList;
    },
    CLEAR_MENU_LIST(state) {
        state.menuList = [];
    }
};

const actions = {
    async fetchMenuList({commit}) {
        try {
            const res = await permissionUser();
            const data = Array.isArray(res) ? res : res.data || [];
            commit('SET_MENU_LIST', data);
            return data;
        } catch (error) {
            commit('SET_MENU_LIST', []);
            return Promise.reject(error);
        }
    },
    clearMenuList({commit}) {
        commit('CLEAR_MENU_LIST');
    }
};

const getters = {
    menuList: state => state.menuList,
    /**
     * 根据当前路由获取权限信息
     * @param {string} path - 当前页面路由（如 /patient、/data 等）
     * @returns {Object} { add: Boolean, delete: Boolean, edit: Boolean, query: Boolean }
     */
    pagePermission: (state) => (path) => {
        const empty = { add: false, delete: false, edit: false, query: false };
        if (!path || !state.menuList || !state.menuList.length) return empty;

        // 在菜单中查找当前页面节点（包括二级子节点）
        let target = null;
        for (const item of state.menuList) {
            if (item.path === path) {
                target = item;
                break;
            }
            if (item.children && item.children.length) {
                const child = item.children.find(c => c.path === path);
                if (child) {
                    target = child;
                    break;
                }
            }
        }

        if (!target || !target.permission) return empty;

        return {
            add: target.permission.includes('增'),
            delete: target.permission.includes('删'),
            edit: target.permission.includes('改'),
            query: target.permission.includes('查')
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
